import api from './api'

export const simpananBerjangkaService = {
  // Get all accounts
  getAccounts: (params = {}) => {
    return api.get('/simpanan-berjangka/accounts', { params })
  },

  // Get account detail
  getAccountDetail: (id) => {
    return api.get(`/simpanan-berjangka/accounts/${id}`)
  },

  // Create new account
  createAccount: (data) => {
    return api.post('/simpanan-berjangka/accounts', data)
  },

  // Calculate interest (preview)
  calculateInterest: (id) => {
    return api.get(`/simpanan-berjangka/accounts/${id}/calculate-interest`)
  },

  // Withdraw interest
  withdrawInterest: (id, jumlahBunga, keterangan = '') => {
    return api.post(`/simpanan-berjangka/accounts/${id}/withdraw-interest`, { jumlahBunga, keterangan })
  },

  // Close account
  closeAccount: (id, jenisPenutupan, keterangan = '') => {
    return api.post(`/simpanan-berjangka/accounts/${id}/close`, { jenisPenutupan, keterangan })
  },

  // Get transactions
  getTransactions: (simpananId) => {
    return api.get(`/simpanan-berjangka/transactions/${simpananId}`)
  },

  // Preview admin fee
  previewAdminFee: (nettoTarget, tenorBulan) => {
    return api.get('/simpanan-berjangka/preview-admin-fee', { params: { nettoTarget, tenorBulan } })
  },

  // Get jatuh tempo warnings
  getJatuhTempoWarnings: () => {
    return api.get('/simpanan-berjangka/jatuh-tempo')
  }
}

export default simpananBerjangkaService